import React from "react";
import { Button } from "react-bootstrap";
import { Tooltip } from "../utils/components";
import { SortByAlphaIcon, SortRoundedIcon } from "../utils/components/icons";
import { uniqueKey } from "../utils/functions/uniqueKey";

class ConditionsTableHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      liste: [],
      dirty: [],
      labels: [],
      preisLabels: [],
      sort: {
        kennziffer: { active: false, directionUp: false },
        bezeichnung: { active: true, directionUp: false },
        preis_0: { active: false, directionUp: false },
        preis_2: { active: false, directionUp: false }
      }
    };
    // bind event listeners to this
    this.toggleSort = this.toggleSort.bind(this);
    this.resetKondition = this.resetKondition.bind(this);
  }

  get liste() {
    return Array.isArray(this.props.liste) ? this.props.liste : this.state.liste;
  }

  get labels() {
    return Array.isArray(this.props.labels) ? this.props.labels : this.state.labels;
  }

  get preisLabels() {
    return Array.isArray(this.props.preisLabels) ? this.props.preisLabels : this.state.preisLabels;
  }

  get sort() {
    return typeof this.props.sort === "object" && this.props.sort ? this.props.sort : this.state.sort;
  }

  get dirty() {
    return Array.isArray(this.props.dirty) ? this.props.dirty : this.state.dirty;
  }

  onChange(changed) {
    if (typeof this.props.onChange) this.props.onChange(changed);
    this.setState(changed);
  }

  calculateIsDirty(dirtyArray) {
    if (!Array.isArray(dirtyArray)) return true;
    let isDirty = false;
    dirtyArray.forEach(d => {
      isDirty = isDirty || !!d;
    });
    return isDirty;
  }

  resetKondition(e) {
    if (!e) return;
    const target = e.currentTarget || e.target;
    if (!target) return;
    const idx = Number(target.dataset.reset);
    if (isNaN(idx)) return;
    // TODO reset all values in data to original value
    let data = [...this.liste];
    data.forEach(i => i.resetKondition(idx));
    let dirty = [...this.dirty];
    dirty[idx] = this.calculateIsDirty(data.map(i => i.isDirty(idx)));
    this.onChange({ resetKondition: idx, data, dirty });
  }

  renderDefaultHeader() {
    if (this.liste.length < 1 || this.props.variant !== "default") return null;
    let tableHeader = [];
    // Kennziffer nicht anzeigen, wenn in der Liste kein solcher wert enthalten ist
    tableHeader.push(<th key="std" className="d-none d-lg-table-cell">
      <span className="aria-visible">Kenn&shy;ziffer</span>
    </th>);
    this.labels.forEach((label) => {
      tableHeader.push(
        <th key={uniqueKey(label)} className="pb-0">
          <div className="text-end">
            {label}
          </div>
        </th>
      );
    });
    return tableHeader;
  }

  toggleSort(e) {
    if (!e || this.props.disabled) return;
    let sortIdx = e.target && e.target.dataset ? e.target.dataset.sort : "";
    if (!sortIdx && e.currentTarget && e.currentTarget.dataset) sortIdx = e.currentTarget.dataset.sort;
    if (!this.sort || !this.sort[sortIdx]) return;
    let sort = { ...this.sort };
    if (sort[sortIdx].active) {
      sort[sortIdx].directionUp = !sort[sortIdx].directionUp;
    } else {
      Object.keys(sort).forEach(sKey => { sort[sKey].active = false; });
      sort[sortIdx].active = true;
    }
    this.onChange({ sort });
  }

  renderTableHeader() {
    if (this.liste.length < 1 || this.props.variant === "range" || this.props.variant === "default") return null;
    let tableHeader = [];
    let showSort = this.sort["kennziffer"] || {};
    tableHeader.push(<th key="kennziffer" className={"kennziffer" + (showSort.active ? " sortindex" : "")}>
      <div className="d-sm-flex d-md-flex justify-content-between">
        Kennziffer
        <SortRoundedIcon
          data-sort="kennziffer"
          onClick={this.toggleSort}
          className={
            "ms-one"
            + (this.sort["kennziffer"].directionUp ? "" : " flipped")
          }
        />
      </div>
    </th>);
    showSort = this.sort["bezeichnung"] || {};
    tableHeader.push(<th key="produkt" className={"bezeichnung" + (showSort.active ? " sortindex" : "")}>
      <div className="d-sm-flex d-md-flex justify-content-between">
        Produkt
        <SortByAlphaIcon
          data-sort="bezeichnung"
          onClick={this.toggleSort}
        />
      </div>
    </th>);
    if (this.preisLabels && this.preisLabels[0]) {
      showSort = this.sort["preis_0"] || {};
      tableHeader.push(<th key={"preis_0"} className={"row-2 column-1 preis" + (showSort.active ? " sortindex" : "")}>
        <div className="d-sm-flex d-md-block justify-content-between">
          {this.preisLabels[0]}
          <SortRoundedIcon
            data-sort="preis_0"
            onClick={this.toggleSort}
            className={this.sort["preis_0"].directionUp ? "" : "flipped"}
          />
        </div>
      </th>);
    }
    this.labels.forEach((h) => {
      tableHeader.push(
        <th key={uniqueKey(h)} className="row-3 hidden-sm">
          <div className="d-flex justify-content-between align-items-center">
            {h}
          </div>
        </th>
      );
    });
    return tableHeader;
  }

  renderStufenHeader() {
    if (this.props.variant !== "range") return null;
    let tableHeader = [];
    tableHeader.push(<th key="band" className="band">
      Band
    </th>);
    tableHeader.push(<th key="maxWert" className="wert">
      Gegenwert
    </th>);
    this.labels.forEach((h, idx) => {
      tableHeader.push(
        <th key={uniqueKey(h)} className={idx === 0 ? "column-1" : ""}>
          <div className="d-flex justify-content-between align-items-center">
            {h}
          </div>
        </th>
      );
    });
    if (this.liste.length < 5 && !this.props.readOnly) {
      tableHeader.push(<th key="aktion" className="aktion">
        <span className="aria-visible">Aktion</span>
      </th>);
    }

    let subHeader = [];
    if (this.props.onReset && !this.props.readOnly) {
      subHeader.push(<th key="sub-band" />);
      subHeader.push(<th key="sub-wert" />);
      this.labels.forEach((h, idx) => {
        subHeader.push(
          <th key={`sub-${uniqueKey(h)}`}>
            <Button variant="warning" size="sm" className="w-100" data-field={idx} onClick={this.props.onReset}>
              zurücksetzen
              <Tooltip>Setzt den Wert auf den Standard zurück</Tooltip>
            </Button>
          </th>
        );
      });
      if (this.liste.length < 5) {
        subHeader.push(<th key="sub-aktion" />);
      }
    }

    return [
      <tr key="header-row">{tableHeader}</tr>,
      (subHeader.length > 0 ? <tr key="sub-header-row">{subHeader}</tr> : null)
    ];
  }

  render() {
    let tableHeader;
    if (this.props.variant === "default") {
      tableHeader = this.renderDefaultHeader();
    } else if (this.props.variant === "range") {
      tableHeader = this.renderStufenHeader();
    } else {
      tableHeader = this.renderTableHeader();
    }

    if (this.props.variant === "range") {
      return (
        <thead>
          {this.props.children}
          {tableHeader}
        </thead>
      );
    }

    return (
      <thead>
        {this.props.children}
        <tr>
          {tableHeader}
        </tr>
      </thead>
    );
  }

}

export default ConditionsTableHeader;
